import { render, staticRenderFns } from "./newWorks.vue?vue&type=template&id=75904c98&scoped=true&"
import script from "./newWorks.vue?vue&type=script&lang=js&"
export * from "./newWorks.vue?vue&type=script&lang=js&"
import style0 from "./newWorks.vue?vue&type=style&index=0&id=75904c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75904c98",
  null
  
)

export default component.exports